import { Button, Container, makeStyles } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { connect } from "common/connect";
import EventFormatHelper from "common/helpers/eventFormatHelper";
import { PanZoomHelper } from "common/helpers/panZoomHelper";
import Store from "common/store";
import StoreKeys from "common/storeKeys";
// eslint-disable-next-line no-unused-vars
import { EventFormat } from "common/types/EventFormat";
import * as React from "react";
import { Helmet } from "react-helmet";
import { Colors } from "styles/Colors";
import EventFormatEditor from "./EventFormatEditor/EventFormatEditor";
import EventFormatSelector from "./EventFormatSelector";

/**
 * @typedef ComponentProps
 * @type {object}
 * @property {EventFormat} currentFormat
 */

const propKeys = {
	currentFormat: StoreKeys.EVENTFORMATBUILDER.CURRENT_FORMAT,
};

const classStyles = makeStyles((theme) => ({
	listContainer: {
		height: "100%",
		display: "flex",
		flexDirection: "column",
		paddingBottom: theme.spacing(2),
		[theme.breakpoints.up("sm")]: {
			paddingBottom: theme.spacing(3),
		},
	},
	editorContainer: {
		height: "100%",
		display: "flex",
		flexDirection: "column",
		paddingBottom: theme.spacing(2),
		[theme.breakpoints.up("sm")]: {
			paddingBottom: theme.spacing(3),
		},
	},
	titleRow: {
		flex: "0 0 auto",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
	},
	addButton: {
		color: Colors.primary,
		backgroundColor: Colors.panelLight,
		paddingLeft: 20,
		paddingRight: 20,
	},
}));

function addEventFormat() {
	PanZoomHelper.resetView(0, 0, 0.75);
	const formatBuilder = EventFormatHelper.getEventFormatBuilder();
	Store.set(StoreKeys.EVENTFORMATBUILDER.CURRENT_FORMAT, formatBuilder);
}

/**
 * @param {ComponentProps} props
 */
function EventFormatBuilderC(props) {
	const { currentFormat } = props;
	const isList = !currentFormat;
	const classNames = classStyles();

	return (
		<Container
			maxWidth={false}
			className={isList ? classNames.listContainer : classNames.editorContainer}
		>
			<Helmet>
				<title>Pickstop - Event Format Builder</title>
			</Helmet>
			{isList && (
				<div className={classNames.titleRow}>
					<h1>Event Format Builder</h1>
					<Button
						onClick={addEventFormat}
						startIcon={<Add color="primary" />}
						className={classNames.addButton}
					>
						Add
					</Button>
				</div>
			)}
			{isList && <EventFormatSelector />}
			{!isList && <EventFormatEditor />}
		</Container>
	);
}

function EventFormatBuilder(props) {
	return connect(<EventFormatBuilderC />, propKeys, props);
}

export default EventFormatBuilder;
